export const OPTIMIZATION_RESULTS_REVALIDATION_RETRY_DELAY_MS = 900;
export const OPTIMIZATION_RESULTS_REVALIDATION_RETRY_LIMIT = 3;

function normalizeText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function shouldRetryOptimizationResultsRevalidation({
  attemptCount = 0,
  authoritativeRunId = "",
  currentDispatchDate = "",
  currentDispatchPeriod = "",
  jobDispatchDate = "",
  jobDispatchPeriod = "",
  resultCommitted = false,
  revalidatorState = "idle",
  status = "idle",
  trackedRunId = "",
} = {}) {
  if ((currentDispatchDate && jobDispatchDate && currentDispatchDate !== jobDispatchDate)
    || (currentDispatchPeriod && jobDispatchPeriod && currentDispatchPeriod !== jobDispatchPeriod)) {
    return false;
  }
  const normalizedStatus = normalizeText(status).toLowerCase();
  const isCommittedTerminal = normalizedStatus === "completed"
    || (normalizedStatus === "cancelled" && resultCommitted === true);
  const normalizedTrackedRunId = normalizeText(trackedRunId);
  const normalizedAuthoritativeRunId = normalizeText(authoritativeRunId);
  const normalizedAttemptCount = Number.isFinite(Number(attemptCount))
    ? Math.max(0, Math.floor(Number(attemptCount)))
    : 0;

  return isCommittedTerminal
    && normalizedTrackedRunId.length > 0
    && normalizedAuthoritativeRunId !== normalizedTrackedRunId
    && revalidatorState === "idle"
    && normalizedAttemptCount < OPTIMIZATION_RESULTS_REVALIDATION_RETRY_LIMIT;
}
